module.exports = __webpack_public_path__ + "static/media/Comentarios_Sobre_el_ELL_Assessment_Test.abfd4f2f.docx";